import {register, setEditorSettings} from '@builder.io/sdk-react'
import {designTokens} from '../../../designTokens'

setEditorSettings({customInsertMenu: true})
register('insertMenu', {
    name: 'Custom Components',
    priority: 1,
    items: [
        {name: 'Core:Button'},
        {name: 'Link'},
        {name: 'LinkWrapper'},
        {name: 'Breadcrumb'},
        {name: 'DownloadAssetButton'},
        {name: 'Heading'},
        {name: 'BodyCopy'},
        {name: 'IconPicker'},
        {name: 'IconLinksGrid'},
        {name: 'HeaderBanner'},
        {name: 'NavDrawer'},
        {name: 'Categories'},
        {name: 'Eyebrow'},
        {name: 'v1: Popover'},
        {name: 'Modal'},
        {name: 'v1: Carousel'},
        {name: 'ProductCarousel'},
        {name: 'Builder:Accordion'},
        {name: 'Minicart'},
        {name: 'Search'},
        {name: 'ThemeBox'},
        {name: 'GuestContent'},
        {name: 'AuthContent'},
        {name: 'StickyWrapper'},
        {name: 'ExpandableContent'},
        {name: 'ToggleTextButton'},
        {name: 'Product Recommendations'},
        {name: 'ProductTile'},
        {name: 'Expense Dashboard'},
        {name: 'ToggleContextProvider'},
        {name: 'ToggleContent'},
        {name: 'ToggleButton'},
        {name: 'TPABalance'},
        {name: 'InteractiveSpendingTool'}
    ]
})

register('insertMenu', {
    name: 'PLP Components',
    priority: 4,
    items: [
        {name: 'CategoryProductGrid'},
        {name: 'CategoryFiltersBanner'},
        {name: 'SortPopover'},
        {name: 'DrawerFilters'},
        {name: 'SortPopover'},
        {name: 'DrawerFilters'},
        {name: 'PlpBuilderBlock'}
    ]
})
register('insertMenu', {
    name: 'Article Components',
    priority: 5,
    items: [{name: 'ArticleTopicCard'}, {name: 'ArticleCard'}, {name: 'ArticleGrid'}]
})

register('insertMenu', {
    name: 'Form Elements',
    priority: 6,
    items: [{name: 'EmailSignup'}]
})

register('insertMenu', {
    name: 'Account-Related Components',
    priority: 7,
    items: [{name: 'UserName'}, {name: 'SignOutButton'}, {name: 'PerksAndRewardsSection'}]
})

register('insertMenu', {
    name: 'Drawer Components',
    priority: 8,
    items: [{name: 'MainNavigation'}, {name: 'AccountDrawer'}]
})

register('editor.settings', {
    designTokens: {
        colors: [
            ...(designTokens.color || [])
            // Custom HSA/FSA/CORE Colors
        ],
        shape: [
            ...(designTokens.shape || [])
            // ...add other shape tokens if needed
        ],
        fontSize: [
            ...(designTokens['font-size'] || [])
            // ...add other font-size tokens if needed
        ]
        // Add more token groups as needed
    }
})

register('insertMenu', {
    name: 'TrustArc Components',
    priority: 9,
    items: [{name: 'TrustArcBanner'}]
})

register('insertMenu', {
    name: 'Hero Components',
    priority: 2,
    items: [{name: 'HeroTwoColumn'}, {name: 'HeroThreeColumn'}, {name: 'HeroSingleColumn'}]
})
